import { Injectable } from '@angular/core';
import { ApiHttpClientService } from '../../api-http-client.service';
import { environment } from 'src/environments/environment';
import { TipoMaterial } from 'src/app/models/api/comercial/tipo-material';
import { StatusComercial } from 'src/app/models/api/comercial/status-comercial';

@Injectable({
  providedIn: 'root'
})
export class ApiStatusComercialService {
  private baseUrl = 'StatusComercial';
  private controller: ApiHttpClientService;

  constructor(
    private api: ApiHttpClientService
  ) {
    this.controller = this.api
      .useBaseUrl(environment.microservice.comercial)
      .useBaseUrl(this.baseUrl);
  }

  getAll() {
    return this.controller.unwrap().get<StatusComercial[]>('');
  }
}
